import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function DropZone({ saveFile }) {
  const theme = useTheme();
  const matches = useMediaQuery("(min-width:600px)");
  const onDrop = useCallback((acceptedFiles) => {
    saveFile(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: [".jpg", ".png", ".jpeg", ".JPG", ".PNG", ".JPEG"],
    maxSize: 2 * 1024 * 1024,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        height: "100px",
        justifyContent: "center",
        alignItems: "center",
        width: "-webkit-fill-available",
        border: "dashed",
        backgroundImage: "url(/upload.png)",
        padding: "20px",
        margin: "30px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundColor: "#4b8c0e",
        borderColor: "#182d04",
        borderRadius: "10px",
        position: "relative",
      }}
    >
      <input {...getInputProps()} />
      <Typography
        variant="subtitle2"
        textAlign="center"
        style={{ padding: 20 }}
      >
        {/* {isDragActive
          ? "Arroja aqui tus archivos"
          : "Arrastra aqui o click para agregar una foto"} */}
      </Typography>
      <label style={{ position: "absolute", bottom: "-1.5rem" }}>
        {matches
          ? `Archivos aceptados ".jpg", ".png", ".jpeg",
        ".JPG", ".PNG", ".JPEG" de hasta 2MB`
          : "Archivos de hasta 2 MB"}
      </label>
    </div>
  );
}
